import moment = require("moment");
import * as _ from "lodash";

export class Utility {

	public static DATE_FORMAT = 'DD.MM.YYYY';
	public static PICKER_DATE_FORMAT = 'dd.MM.yyyy';
	public static TIME_FORMAT = 'HH:mm';
	public static YEAR_AND_MONTH_FORMAT = 'YYYY / MM';
	public static DATETIME_FORMAT = Utility.DATE_FORMAT + ' ' + Utility.TIME_FORMAT;
	public static LOCALE = 'sr';

	public static cloneDeep = _.cloneDeep;
	public static isEqual = _.isEqual;
	public static map = _.map;
	public static reduce = _.reduce;
	public static assign = _.assign;
	public static isArray = _.isArray;
	public static isString = _.isString;
	public static isFunction = _.isFunction;
	public static range = _.range;

	public static isNullOrUndefined(obj: any) {
		return typeof obj === "undefined" || obj === null;
	}

	public static checkIfItemExists<T>(arr: Array<T>, item: T): boolean {
        var res = false;
        for (var i = arr.length - 1; i >= 0; i--) {
            if (arr[i] == item) {
                res = true;
                break;
            }
        }
        return res;
	}

	static formatString (value: string): string {
		if (Utility.isNullOrUndefined(value)) return ''
		return value
	}

	static formatDateString (value: string): string {
		if (Utility.isNullOrUndefined(value)) return null
		return value
	}

	static formatPermissionString (value: string): string[] {
		let permissions = (Utility.formatString(value)).split(',')
		if(permissions[0] == ""){permissions.shift()}
		return permissions
	}

	static formatGrantedRoles (departmentRoles: any, departmentId: string, roles: any): string[] {
		if (!Array.isArray(departmentRoles)) departmentRoles = []
		let activeRoles:string[] = []
		if(departmentRoles!=[]){
			for(let item of departmentRoles){
				if(item.departmentId == departmentId && departmentId != "all"){
					for(let itemOfRoles of roles){
						if(itemOfRoles.id == item.roleId){
							activeRoles.push(itemOfRoles.name)
						}
					}
				}
				if(item.departmentId == undefined){
					for(let itemOfRoles of roles){
						if(itemOfRoles.id == item.roleId){
							activeRoles.push(itemOfRoles.name)
						}
					}
				}
			}
		}
		let newActiveRoles:string[] = [];
		activeRoles.forEach((c) => {//remove duplicated active roles
            if (!newActiveRoles.includes(c)) {
                newActiveRoles.push(c);
            }
        })
		return newActiveRoles
	}

	static formatUngrantedRoles (departmentRoles: any, departmentId: string, allRoles: any): string[] {
		if (!Array.isArray(departmentRoles)) departmentRoles = []
		let unactiveRoles:string[] = []

		const activeRoles:string[] = this.formatGrantedRoles(departmentRoles, departmentId, allRoles)
		if(activeRoles!=[]){
			for(const itemOfAllRoles of allRoles){
				let foundedRole = false
				for(const itemOfGrantedRoles of activeRoles){
					if(itemOfGrantedRoles == itemOfAllRoles.name){
						foundedRole = true
					}
				}
				if(!foundedRole) unactiveRoles.push(itemOfAllRoles.name)
			}
		}
		return unactiveRoles
	}

	static formatNumber(value: number, decimals: number): string{
		//Handle null and undefined
		if(value == null){
			return '-';
		}
		var roundedValue = decimals != null ? Utility.roundOnDecimals(value, decimals) : value;
		return Utility.formatNumberWithCommas(roundedValue);
	}

	static formatPrice(value: number, decimals: number): string{
		//Handle null and undefined
		if(value == null){
			return '-';
		}

		if(typeof value !== 'number' ) {
			return '-';
		}

		var roundedValue = decimals != null ? Utility.roundOnDecimals(value, decimals) : value;
		return Utility.formatNumberWithCommas(roundedValue);
	}

	static formatBoolean(value: boolean): string{
		//Handle null and undefined
		if(value == null){
			return '-';
		}
		return value == true ? 'Yes' : 'No';
	}

	static formatDate(dateAsString: string): string{
		return moment(dateAsString).format(Utility.DATE_FORMAT);
	}

	static formatDateTime(dateAsString: string): string{
		return moment(dateAsString).format(Utility.DATETIME_FORMAT);
	}

	//Inspired by: http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
	private static formatNumberWithCommas(value: number) :string {
		var parts = value.toString().split(".");
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		return parts.join(".");
	}

	//Inspired by: http://www.jacklmoore.com/notes/rounding-in-javascript/
	private static roundOnDecimals(value: number, decimals: number): number {
		return Number(Math.round(<any>(value+'e'+decimals))+'e-'+decimals);
	}

    static removeItem<T>(arr: Array<T>, item: T): Array<T> {
        for (var i = arr.length - 1; i >= 0; i--) {
            if (arr[i] == item) {
                this.putOnLastPosition(arr, i);
                arr.pop();
                break;
            }
        }
        return arr;
    }

    private static putOnLastPosition<T>(arr: Array<T>, index: number) {
        if (index != arr.length - 1) {
            for (var i = index; i < arr.length - 1; i++) {
                var prev = arr[i];
                arr[i] = arr[i + 1];
                arr[i + 1] = prev;
            }
        }
    }

	public static clone<T>(instance: T): T {
		const copy = new (instance.constructor as { new (): T })();
		Object.assign(copy, instance);
		return copy;
	}

	public static validatePhone(value: any): boolean {
		let regex = /^[+]?([0-9]|[\(]|[\)]|-|[\s]|[\/])*$/g;
		return regex.test(value);
	}

	public static validateEmail(value: any): boolean {
		let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return regex.test(String(value).toLowerCase());
	}

	public static validateStringLength(value: any, length: number): boolean {
		return value.length === length;
	}

	public static validatePersonalId(value: any): number {
		if (!Utility.validateStringLength(value, 13)) return 1 //neodgovarajuca duzina jmbg

		let daysInMonth: number[] = [31,28,31,30,31,30,31,31,30,31,30,31]
		const now = new Date()
		const day = parseInt(value.substr(0,2))
		const month = parseInt(value.substr(2,2))
		let year = parseInt(value.substr(4,3))
		if (year < 100){
			year += 2000 //born after 2000.
		}else{
			year += 1000 //born before 2000.
		}
		const personalIdDate = (new Date(year, month-1, day)).getTime()

		if(personalIdDate > now.getTime()) return 2 //uneti datum Jmbg veci od danasnjeg datuma

		if((year > now.getFullYear()) || year < 1900) return 3 // neodgovarajuca godina (5,6,7 cifra jmbg)

		if((month > 12) || (month < 1)) return 4 // neodgovarajuci mesec (3,4 cifra jmbg)

		if(((year % 4) === 0) && (((year % 100) !== 0) || ((year % 400) !== 0))) daysInMonth[1]=29 //prestupna godina

		if((day < 1) || (day > daysInMonth[month-1])) return 5 //neodgovarajuci dan (1,2 cifra jmbg)

		//formula za racunanje kontrolnog zbira
		let sum = 0
		for (let i=0; i<6; i++){
			sum += ((7-i)*(parseInt(value[i])+parseInt(value[6+i])))
		}
		let rest = sum % 11

		if(rest == 1) return 6 //nedozvoljen kontrolni broj

		let controlNumber = 11 - rest
		if(controlNumber == 11) controlNumber=0

		if(controlNumber != parseInt(value[12])) return 7 //provera ispravnosti kontrolnog broja

		return 0 //bez grešaka, jmbg validan
	}

	public static isNum(value: any): boolean {
		return Number.isInteger(Number.parseInt(value))

	}

	public static compareForSorting(key: any, order: string = 'asc') {

		return function innerSort(a: any, b: any) {
			if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
				return 0;
			}

			const varA = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key];
			const varB = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key];

			let comparison = 0;
			if (varA > varB) {
				comparison = 1;
			} else if (varA < varB) {
				comparison = -1;
			}

			return order === 'desc' ? (comparison * -1) : comparison;
		};
	}

	static not(a: string[], b: string[]) {
		return a.filter((value) => b.indexOf(value) === -1);
	}

	static intersection(a: string[], b: string[]) {
		return a.filter((value) => b.indexOf(value) !== -1);
	}

	public static addThousandSeparator(num: number, separator: string = " ") {
		const t = "" + num;
		const numberOfInserts = Math.floor((t.length - 1) / 3);
		if (numberOfInserts === 0) {
			return t;
		}
		let res = "";
		let cnt = 0;
		for (let i = t.length - 1; i >= 0; i--) {
			res = t[i] + res;
			cnt++;
			if (cnt % 3 === 0) {
				res = separator + res;
			}

		}
		return res;
	}
}
